import { useEffect } from 'react';

import { SpotlightRing } from '@/components/SpotlightRing';
import { useAgentChat } from '@/pages/aiagent/AgentChatProvider';

/**
 * <b>AI 가 짚은 자리</b>를 반짝인다 (사용자 지시 2026-09-23: "표시해줘 이런 말을 하면 해당하는
 * 부분을 하이라이트 해주도록").
 *
 * <h2>왜 카드가 아니라 테두리인가</h2>
 * 「오른쪽 위 파란 [자료 입력] 버튼을 누르세요」 는 <b>화면을 글로 옮긴 말</b>이다. 그 화면이
 * 눈앞에 있는데 그렇게 답하는 것은, 사용자에게 우리 문장과 자기 화면을 대조하는 일을 시키는 것이다.
 * 짚으면 그 일이 없어진다.
 *
 * <h2>설명을 붙이지 않는다</h2>
 * 「여기입니다 ✕」 같은 말풍선을 테두리 옆에 세우지 않는다. 할 말은 <b>대화창의 답변</b>이 이미
 * 하고 있고(그 문장을 읽고 고개를 든 사람이 보는 것이 이 테두리다), 화면에 설명을 한 벌 더 깔면
 * 짚어 준 것 자체가 가려진다.
 *
 * <h2>누르면 꺼진다</h2>
 * 짚어 준 목적은 <b>그것을 누르는 것</b>이다. 누르고 나면 할 일이 끝났으므로 테두리도 사라져야
 * 한다 — 남아 있으면 다음 화면까지 따라가 「아직 뭔가 남았다」 로 읽힌다.
 *
 * <p>어디를 눌러도 끈다. 짚어 준 자리만 세면 <b>그 옆의 다른 버튼을 누른 사람</b>에게는 영영
 * 안 꺼지고, 그 사람은 끄는 방법을 배운 적이 없다.
 */
export function AgentSpotlight() {
  const { highlight, clearHighlight } = useAgentChat();
  const target = highlight?.target ?? null;

  useEffect(() => {
    if (!target) return;

    /*
      ★ 마우스를 **뗄 때** 끈다(`click` 이 아니라 `pointerup`). 짚은 자리가 모달을 여는 버튼이면
        그 모달이 `click` 을 삼키는 경우가 있고, 그러면 테두리만 남아 새 창 위를 떠다닌다.

      ★ capture 로 듣는다 — 중간에서 멈추는(`stopPropagation`) 핸들러가 적지 않다.
    */
    const done = () => clearHighlight();
    window.addEventListener('pointerup', done, true);
    return () => window.removeEventListener('pointerup', done, true);
  }, [target, clearHighlight]);

  // 화면 밖이면 굴려서 보여 준다 — 「어디야」 에 답한 자리가 스크롤 아래면 반짝여도 안 보인다.
  return <SpotlightRing target={target} attribute="data-tour" scrollIntoView />;
}
